// __CKEDITOR_BASEPATH__ is set in config/webpack/BaseConfig.js
// eslint-disable-next-line no-undef
window.CKEDITOR_BASEPATH = __CKEDITOR_BASEPATH__
